import { Link } from 'react-router-dom';
import React from 'react';

export default function InvalidPage() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-100">
            <div className="rounded bg-white p-6 shadow-md">
                <h1 className="mb-4 text-2xl font-bold">Your link is expired. Please contact with your physiotherapist</h1>
            </div>
        </div>
    );
}
